import { createContext } from '@chakra-ui/react-utils';
import { FilterContextType } from './Filter.types';

export const [FilterContext, useFilterContext] = createContext<FilterContextType>({
  name: 'FilterContext',
});
